import { Body, Equator, Horizon, Observer } from "astronomy-engine";

const BODIES = [
  [Body.Moon, "Kuu"],
  [Body.Venus, "Venus"],
  [Body.Mars, "Mars"],
  [Body.Jupiter, "Jupiter"],
  [Body.Saturn, "Saturnus"],
];

export function celestialObjects(date, latitude, longitude, altitudeMeters = 0) {
  const observer = new Observer(latitude, longitude, altitudeMeters);
  return BODIES.map(([body, name]) => {
    const equatorial = Equator(body, date, observer, true, true);
    const horizontal = Horizon(date, observer, equatorial.ra, equatorial.dec, "normal");
    return {
      id: name.toLowerCase(),
      name,
      azimuth: horizontal.azimuth,
      elevation: horizontal.altitude,
      kind: body === Body.Moon ? "moon" : "planet",
    };
  });
}
